<div class="typing-indicator-icon">
  <i class="a"></i>
  <i class="b"></i>
  <i class="c"></i>
</div>
{{ typingAdminsMessage }}
